import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: true,
      isSubmitting: false,
      MODAL_INSTALL_APP: 'MODAL_INSTALL_APP',
      selectedApp: null,
    }
  },
  computed: {
    ...mapState('treesoft', {
      pricing: 'pricing',
    }),
    ...mapGetters({
      auth: 'getAuth',
      getApps: 'getApps',
    }),
    ...mapGetters([
      'getShopInstalledApps',
      'getFreeTrialDaysLeft',
      'isFreeTrialLive',
    ]),
    apps () {
      return this.getApps
    },
  },
  methods: {
    ...mapActions('treesoft', {
      getPricing: 'getPricing',
    }),
    handleCloseModal () {
      $(`#${this.MODAL_INSTALL_APP}`).modal('hide')
      this.selectedApp = null
    },
    async handleOpenModalInstallApp (app) {
      this.selectedApp = this.getApps.find((item) => item.app_id == app.app_id)
      this.$nextTick(() => {
        $(`#${this.MODAL_INSTALL_APP}`).modal('show')
      })
    },
    async handleApply ({ appId, moduleIds }) {
      this.isSubmitting = true
      const apps_loading_duration = {
        1: 1000 * 10, // POS
        2: 1000 * 3, // Products
        3: 1000 * 10, // IMS
        8: 1000 * 1, // Report
        11: 500, // Contacts
        12: 1000 * 10, // Accounting
      }
      await this.startProgress(apps_loading_duration[appId] || 1000 * 5)
      await this.$store.dispatch('installApp', {
        app_id: appId,
        module_ids: moduleIds,
      })
      this.notify(this.$vs, {
        text: this.$t('apps.installapp.message.installsuccess'),
        color: 'success',
        icon: 'cloud',
      })
      this.isSubmitting = false
      this.handleCloseModal()
    },
    async handleUninstall ({ appId }) {
      this.isSubmitting = true
      await this.startProgress(1000 * 1)
      await this.$store.dispatch('uninstallApp', {
        app_id: appId,
      })
      this.notify(this.$vs, {
        text: this.$t('apps.installapp.message.uninstallsuccess'),
        color: 'success',
        icon: 'cloud',
      })
      this.isSubmitting = false
      this.handleCloseModal()
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/installApp.js